<h2 mat-dialog-title class="progress-dialog__title">{{ data.title }}</h2>

<mat-dialog-content class="progress-dialog__content">
  <mat-progress-spinner
    class="progress-dialog__spinner"
    mode="indeterminate"
    color="primary"
    diameter="48"
    aria-label="Operación en curso"
  ></mat-progress-spinner>

  <div class="progress-dialog__texts">
    <p class="progress-dialog__message">{{ data.message }}</p>
    @if (data.hint) {
    <p class="progress-dialog__hint">{{ data.hint }}</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="handleCancel($event)">
    {{ cancelLabel }}
  </button>
</mat-dialog-actions>
